import { Submittal } from '.'
import { NotificationEventItem } from '../NotificationEventItem'
import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'
import { an } from '../../../utils/an'

/**
 * generates a common NotificationEventItem for commented notification events
 *
 * the key for this NotificationEventItem should be `Commented`
 *
 * ---
 *
 * the name is: Commented
 *
 * the description is: a User comments on a `{commentable}` outside of the normal workflow
 *
 * @param options {@link EditedOptions}
 * @see {@link NotificationEventItem}
 */
export function CommentedNotificationEventItem<ID extends string>({
  id,
  commentable,
}: CommentedOptions<ID>) {
  return new NotificationEventItem({
    id,
    name: 'Commented',
    description: `A User comments on ${an(
      commentable
    )} outside of the normal workflow`,
  })
}

type CommentedOptions<T extends string> = Pick<ComplexEnumItem<T>, 'id'> & {
  /**
   * which commentable object this is for
   */
  commentable:
    | Submittal
    | 'Field Design Change'
    | 'Request For Information'
    | 'Identified Field Issue'
    | 'Issue'
}
